module.exports = __webpack_public_path__ + "static/media/space.09dee1b6.jpg";